import { render } from "./Extend.vue?vue&type=template&id=a5086df4&scoped=true"
import script from "./Extend.vue?vue&type=script&lang=js"
export * from "./Extend.vue?vue&type=script&lang=js"

import "./Extend.vue?vue&type=style&index=0&id=a5086df4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5086df4"]])

export default __exports__